var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalRuleCheckViolations',{attrs:{"visible":_vm.visible,"violations":_vm.violations,"featureDismissViolationEnabled":_vm.featureDismissViolationEnabled},on:{"cancel":_vm.cancel,"dismissViolations":_vm.dismissViolations}})
}
var staticRenderFns = []

export { render, staticRenderFns }